import './App.css'
import Aos from 'aos';
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Footer from '../src/components/Footer'
import Navbar from '../src/components/Navbar'
import Splash from '../src/pages/Splash'
import Home from '../src/pages/Home'
import About from '../src/pages/About'
import Contact from '../src/pages/Contact'
import Carrer from '../src/pages/Carrer'
import Services from '../src/pages/Services'
import WhyUs from '../src/pages/WhyUs'

import RealEstate from './pages/other_services/RealEstate'
import Projects from './pages/other_services/Projects'
import HRManagement from './pages/other_services/HRManagement'
import FidelitusGallery from './pages/other_services/FidelitusGallery'


import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";
import { useEffect,useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { LuArrowUpSquare } from "react-icons/lu";
import ScrollToTop from 'react-scroll-up';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';


function App() {

    const [loader,setloader] = useState(true)

  useEffect(()=>{
    setloader(true)
    setTimeout(() => {
      setloader(false)
    }, 2000);
    Aos.init();
  },[])

  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <div>
          <Navbar />
          <Home/> 
          <Footer/>
        </div>
      ),
    },
    {
      path: "/home",
      element: (
        <div>
          <Navbar />
          <Home/> 
          <Footer/>
        </div>
      ),
    },
    {
      path: "/about",
      element: <div>
        <Navbar />
          <About/> 
        <Footer/>
      </div>,
    },
    {
      path: "/why-us",
      element: <div>
        <Navbar />
          <WhyUs /> 
        <Footer/>
      </div>,
    },
    {
      path: "/contact",
      element: <div>
        <Navbar />
          <Contact />
        <Footer/>
      </div>,
    },
    {
      path: "/join_us",
      element: <div>
        <Navbar />
          <Carrer />
        <Footer/>
      </div>,
    },
    {
      path: "/services",
      element: <div>
        <Navbar />
          <Services />
        <Footer/>
      </div>,
    },
   
    {
      path:"/whats-more/real-estate-transaction",
      element: <div>
      <Navbar />
        <RealEstate />
      <Footer/>
    </div>,
    },
    {
      path:"/whats-more/hr-labs",
      element: <div>
      <Navbar />
        <HRManagement />
      <Footer/>
    </div>,
    },
    {
      path:"/blogs",
      element: <div>
      <Navbar />
        <Blogs />
      <Footer/>
    </div>,
    },
    {
      path:"/blogs/detail/:id?",
      element: <div>
      <Navbar />
        <BlogDetail />
      <Footer/>
    </div>,
    },
    {
      path:"/whats-more/projects",
      element: <div>
      <Navbar />
        <Projects />
      <Footer/>
    </div>,
    },
    {
      path:"/whats-more/fidelitus-gallery",
      element: <div>
      <Navbar />
        <FidelitusGallery />
      <Footer/>
    </div>,
    }
    
  ]);

  return (
       <div className='relative w-screen overflow-x-hidden'>
      <Toaster  position="bottom-center" toastOptions={{
          success: {
            style:{
              background:'black',
              color:'white',
              padding:'4px 7px',
              fontSize:'12px',
              borderRadius:'2px',
              iconTheme: {
                fontSize:'4px'
              }
            }
          },
          error: {
            style:{
              background:'black',
              color:'white',
              padding:'4px 7px',
              fontSize:'12px',
              borderRadius:'2px',
              iconTheme: {
                fontSize:'4px'
              }
            }
          }
        }}  />
        {loader ?
        <Splash /> :
        <RouterProvider router={router} />} 

        
        <ScrollToTop showUnder={260}>
            <div className='bg-[#027d9b] group p-[10px] rounded z-50'>
             <LuArrowUpSquare size={20} className='z-30 group-hover:animate-spin text-white opacity-100' />
            </div>
        </ScrollToTop>

       
    </div>
  );
}

export default App;
